import { Search } from 'lucide-react';
import { ouvrirPalette } from './ouvrir';

/** Bouton qui ouvre la palette : icône seule sur mobile, champ factice avec raccourci sur bureau. */
export function BoutonRecherche({ className = '' }: { className?: string }) {
  return (
    <button
      type="button"
      onClick={ouvrirPalette}
      aria-label="Rechercher un client, une personne, une ville ou une adresse"
      aria-keyshortcuts="Control+K /"
      className={`cible inline-flex items-center justify-center gap-2 rounded-full border border-bord bg-surface px-3 text-sm text-doux shadow-sm hover:text-texte lg:justify-start lg:rounded-lg lg:pr-2 ${className}`}
    >
      <Search size={18} aria-hidden />
      <span className="hidden lg:inline">Rechercher...</span>
      <kbd className="ml-6 hidden rounded border border-bord px-1.5 py-0.5 font-sans text-xs lg:inline">
        Ctrl K
      </kbd>
    </button>
  );
}
